//以下是所有的个性化配置数据
const CONFIG = {
  env: {
    dev: {
      remoteBaseUrl: "https://cl-test.afnsmart.com/api/0/web/0",
      wssUrl: "wss://cl-test.afnsmart.com/monitor/"
    },
    test: {
      remoteBaseUrl: "https://cl-test.afnsmart.com/api/0/web/0",
      wssUrl: "wss://cl-test.afnsmart.com/monitor/"
    },
    prod: {
      remoteBaseUrl: "https://cl.afnsmart.com/api/0/web/0",
      wssUrl: "wss://cl.afnsmart.com/monitor/"
    }
  },
  //注意,这里虽然对应服务端test和prod环境文件中并没有api路径,但仍需要增加此路径,是因为 nginx 对它进行了处理.
  servePath: '/api',//接口的基础配置信息 : /wnysmart/api

};




export default CONFIG;